import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import Leaves from "./index";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_LEAVE } from "variables/modules";

const leavesRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Leave History",
		basePath: "leaves",
		mainComponent: <Leaves />,
	    layout: "/console",	   
	    subTitle:"Leave",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:5,
		moduleId: MODULE_LEAVE,
	})
]

export default leavesRoutes;